import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=5c256ceb&scoped=true"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"
import style0 from "./OptionList.vue?vue&type=style&index=0&id=5c256ceb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c256ceb",
  null
  
)

export default component.exports